// Module
var code = `<!-- START BUILDING -->
<section class="start-building" aria-labelledby="start-building-headline">

  <div class="start-building__inner">

    <header class="start-building__header">
      <p class="start-building__label">Start building</p>
      <h2 id="start-building-headline" class="start-building__headline">
        Everything you need to go from zero to production.
      </h2>
      <p class="start-building__sub">
        SpyneJS gives you a complete path — from your first generated app to
        production architecture, live tooling, and AI collaboration.
      </p>
      <p class="start-building__bridge">
        Whether you start with the generator, the CLI, or the docs, every path
        leads back to the same structural model: View, Behavior, and Logic.
      </p>
    </header>

    <!-- Tier 1 — Build and reference -->
    <p class="start-building__tier-label">Build and reference</p>
    <ul class="start-building__grid-3" aria-label="Build and reference tools">

      <li class="start-building__card">
        <div class="start-building__card-icon start-building__card-icon--build" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect x="2" y="2" width="12" height="12" rx="2" stroke="#7F77DD" stroke-width="1.5"/>
            <path d="M5 8h6M8 5v6" stroke="#7F77DD" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
        <h3 class="start-building__card-title">Application Generator</h3>
        <p class="start-building__card-body">
          Generate a full-featured SPA online with AI-generated content and a design
          token system. The fastest way to see how SpyneJS structures a real application.
        </p>
        <div class="start-building__card-tags">
          <span class="start-building__tag">Online</span>
          <span class="start-building__tag">AI content</span>
          <span class="start-building__tag">Design tokens</span>
        </div>
        <a data-channel="ROUTE"
           data-event-prevent-default="true"
           data-page-id="configure"
           href="/configure"
           class="start-building__card-link">Generate an app →</a>
      </li>

      <li class="start-building__card">
        <div class="start-building__card-icon start-building__card-icon--build" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M2 4h12M2 8h8M2 12h10" stroke="#7F77DD" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
        <h3 class="start-building__card-title">Spyne CLI</h3>
        <p class="start-building__card-body">
          Scaffold applications and generate SpyneJS core objects from the command
          line: ViewStream, Channel and ChannelFetch, and SpyneTrait. Start with the
          right structure from the first file.
        </p>
        <div class="start-building__card-tags">
          <span class="start-building__tag">ViewStream</span>
          <span class="start-building__tag">Channel</span>
          <span class="start-building__tag">SpyneTrait</span>
        </div>
        <a href="https://github.com/spynejs/spyne-cli" target="_blank" class="start-building__card-link">Install the CLI →</a>
      </li>

      <li class="start-building__card">
        <div class="start-building__card-icon start-building__card-icon--build" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 2h7l3 3v9H3V2z" stroke="#7F77DD" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M10 2v4h4" stroke="#7F77DD" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M5 9h6M5 12h4" stroke="#7F77DD" stroke-width="1.2" stroke-linecap="round"/>
          </svg>
        </div>
        <h3 class="start-building__card-title">Documentation and Reference</h3>
        <p class="start-building__card-body">
          API reference, guides, and tutorials — all on spynejs.com. Everything you
          need to learn the framework and understand its structure, in one place.
        </p>
        <div class="start-building__card-tags">
          <span class="start-building__tag">Guides</span>
          <span class="start-building__tag">API reference</span>
          <span class="start-building__tag">Tutorials</span>
        </div>


        <a   data-channel="ROUTE"
             data-event-prevent-default="true"
             data-page-id="docs"
             data-text="Docs"
             href="/docs/examples"
           class="start-building__card-link">Read the docs →</a>
      </li>

    </ul>

    <!-- Tier 2 — AI collaboration -->
    <p class="start-building__tier-label">AI collaboration</p>
    <ul class="start-building__grid-3" aria-label="AI collaboration tools">

      <li class="start-building__card">
        <div class="start-building__card-icon start-building__card-icon--ai" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 2h7l3 3v9H3V2z" stroke="#5DCAA5" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M10 2v4h4" stroke="#5DCAA5" stroke-width="1.5" stroke-linejoin="round"/>
            <path d="M5 7h6M5 10h4M5 13h3" stroke="#5DCAA5" stroke-width="1.2" stroke-linecap="round"/>
          </svg>
        </div>
        <h3 class="start-building__card-title">AI Reference</h3>
        <p class="start-building__card-body">
          The complete SpyneJS reference documentation in markdown — ready to drop
          into Claude Code, Cursor, Kiro, or any AI tool as structural context for
          your project. Accurate framework knowledge available to your agent from
          the first prompt. No configuration required.
        </p>
        <div class="start-building__card-tags">
          <span class="start-building__tag">Markdown</span>
          <span class="start-building__tag">Claude Code</span>
          <span class="start-building__tag">Cursor · Kiro</span>
        </div>
        <a href="https://spynejs.ai" target="_blank" class="start-building__card-link">Get the AI Reference →</a>
      </li>

      <li class="start-building__card">
        <div class="start-building__card-icon start-building__card-icon--ai" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect x="9" y="2" width="5" height="12" rx="1" stroke="#5DCAA5" stroke-width="1.5"/>
            <path d="M2 4h5M2 8h5M2 12h5" stroke="#5DCAA5" stroke-width="1.5" stroke-linecap="round"/>
            <circle cx="11.5" cy="5.5" r="1" fill="#5DCAA5"/>
          </svg>
        </div>
        <h3 class="start-building__card-title">
          AI Workbench
          <span class="start-building__badge start-building__badge--alpha">Alpha</span>
        </h3>
        <p class="start-building__card-body">
          Prompt AI directly inside SpyneJS through a structured side panel — with
          access to your local file directory and application context. Works like the
          CMS panel: context-aware, structured, and built into the environment you
          already build in.
        </p>
        <div class="start-building__card-tags">
          <span class="start-building__tag">Side panel</span>
          <span class="start-building__tag">File access</span>
          <span class="start-building__tag">Logged-in users</span>
        </div>
        <span class="start-building__card-link start-building__card-link--disabled" aria-disabled="true">Join the alpha <span class="start-building__coming-soon">Coming soon</span></span>
      </li>

      <li class="start-building__card">
        <div class="start-building__card-icon start-building__card-icon--ai" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect x="2" y="6" width="4" height="4" rx="1" stroke="#5DCAA5" stroke-width="1.5"/>
            <rect x="10" y="2" width="4" height="4" rx="1" stroke="#5DCAA5" stroke-width="1.5"/>
            <rect x="10" y="10" width="4" height="4" rx="1" stroke="#5DCAA5" stroke-width="1.5"/>
            <path d="M6 8h2.5M12 6v4" stroke="#5DCAA5" stroke-width="1.2" stroke-linecap="round"/>
          </svg>
        </div>
        <h3 class="start-building__card-title">
          MCP and A2A
          <span class="start-building__badge start-building__badge--new">New</span>
        </h3>
        <p class="start-building__card-body">
          Direct AI assistance through MCP and A2A in Kiro, Claude Code, and Cursor —
          with the Structural Code Map as agent context. For AI codegen platforms and
          cloud services, SpyneJS's native structural understanding of frontend
          architecture opens a new layer of precision for code generation at scale.
        </p>
        <div class="start-building__card-tags">
          <span class="start-building__tag">MCP</span>
          <span class="start-building__tag">A2A</span>
          <span class="start-building__tag">Kiro · Claude Code · Cursor</span>
        </div>
        <div class="start-building__card-links">
          <span class="start-building__card-link start-building__card-link--disabled" aria-disabled="true">Set up MCP <span class="start-building__coming-soon">Coming soon</span></span>
<!--          <a href="#" class="start-building__card-link start-building__card-link&#45;&#45;secondary">Explore codegen integration →</a>-->
        </div>
      </li>

    </ul>

  </div>

</section>
`;
// Exports
module.exports = code;